import { type FC, useMemo } from 'react';

import type { GroupType } from '@/features/boundaries/deedPlotter/call';
import { useSelectionsPanelContext } from '@/features/selectionsPanel/selectionsPanelProvider';

import { DeedPlotterCard } from '../selectionCard/cardVariants/deedPlotterCard';
import { PanelSectionDropdown } from './panelSectionDropdown';

export const DeedSectionDropdown: FC = () => {
  const { selectedDeedFeatures } = useSelectionsPanelContext();

  const deedFeatureCount = useMemo(
    () => selectedDeedFeatures.length,
    [selectedDeedFeatures]
  );

  const selectionCards = useMemo(() => {
    return (
      <>
        {selectedDeedFeatures.map(
          (feature: GroupType & { idx: number }, idx) => (
            <DeedPlotterCard key={feature.idx} feature={feature} idx={idx} />
          )
        )}
      </>
    );
  }, [selectedDeedFeatures]);

  if (!deedFeatureCount) return null;

  return (
    <PanelSectionDropdown sectionCount={deedFeatureCount} title="Deed">
      {selectionCards}
    </PanelSectionDropdown>
  );
};
